module.exports = __webpack_public_path__ + "static/media/failed.9571bfb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/groupBuy/failed.png
// module id = 1913
// module chunks = 6